var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.8018L18.7612 18.9605C18.3799 19.182 17.9467 19.2987 17.5056 19.2987C17.0646 19.2987 16.6314 19.182 16.25 18.9605L5 11.8018M7.5 8.05176H27.5C28.8807 8.05176 30 9.17105 30 10.5518V25.5518C30 26.9325 28.8807 28.0518 27.5 28.0518H7.5C6.11929 28.0518 5 26.9325 5 25.5518V10.5518C5 9.17105 6.11929 8.05176 7.5 8.05176Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.2db8c977cdc46093ac1f92ef7f3e6455.svg";
export { ForwardRef as ReactComponent };